import * as React from 'react';
import * as FluxUtils from 'flux/utils';

import { AppDispatcher, DispatcherBaseAction } from '../dispatcher/AppDispatcher';

interface StoreListenerHandle {
    remove: () => void;
}

export abstract class BaseComponent<T1, T2> extends React.Component<T1, T2> {
    private storeListener: Array<StoreListenerHandle> = [];
    private dispatchTokens: Array<string> = [];

    public componentWillUnmount(): void {
        while (this.storeListener.length) {
            const cb: StoreListenerHandle | undefined = this.storeListener.pop();
            if (cb != null) {
                cb.remove();
            }
        }

        while (this.dispatchTokens.length) {
            const dispatchToken: string | undefined = this.dispatchTokens.pop();
            if (dispatchToken != null) {
                AppDispatcher.unregister(dispatchToken);
            }
        }
    }

    protected addStoreListener(store: FluxUtils.Store<any>, callback: () => void): void {
        this.storeListener.push(store.addListener(callback));
    }

    protected addActionListener(callback: (action: DispatcherBaseAction) => void): void {
        this.dispatchTokens.push(AppDispatcher.register(callback));
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/BaseComponent.tsx